const filters = {
  'filters-breadcrumbs': 'Filters',
  'filters-column-value': 'Value',
  'filters-filter-title': 'Filter',
  'filters-filter-form-value': 'Value',
  'filters-filter-form-value-tooltip': 'This field accepts filterable values such as labels, categories, or tags',
  'filters-filter-form-value-placeholder': 'Choose filter value',
  'filters-attached-to-groups': 'Cannot delete the filter as it is used in groups: ',
  'filters-option-label': 'Label',
  'filters-option-category': 'Category',
  'filters-option-tag': 'Tag',
  'filters-option-combined': 'Combined',
};

export default filters;
